import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {adminAction, SearchManagementOrganizationsUsersAction} from '../action';

function* execute({payload: {organizationId, searchText}}: SearchManagementOrganizationsUsersAction): SagaIterator {
    yield* put(adminAction.setLoading('getUsers', true));
    const response = yield* call(Api.searchOrganizationEmployees, {text: searchText}, {organizationId});

    if (response.isSuccess) {
        yield* put(adminAction.setManagementOrganizationsUsers(response.data));
    } else {
        yield putAll(showBeError(response, t('admin')('subjectsLoading')));
    }
    yield* put(adminAction.setLoading('getUsers', false));
}

/** Runs the admin saga that searches users for the organization-management form. */
export function* searchManagementOrganizationsUsersSaga(): SagaIterator {
    yield takeLatestF('admin/SEARCH_MANAGEMENT_ORGANIZATIONS_USERS', execute);
}
